import { useMutation, gql } from '@apollo/client';

export const useEnviarEmailSimulacao = () => {
  const mutation = gql`
    mutation EnviarEmail($campos: EnviarEmailCampos!) {
      enviarEmailSimulacao(campos: $campos)
    }
  `;

  const [mutate, result] = useMutation(mutation, { errorPolicy: 'ignore' });
  const enviarEmail = (emailColab, calculadoraRE) =>
    mutate({
      variables: {
        campos: {
          emailColab,
          remuneracaoBase: calculadoraRE.getRemuneracaoBase(),
          salario: calculadoraRE.getSalario(),
          transporte: calculadoraRE.getTransporte(),
          refeicao: calculadoraRE.getRefeicao(),
          alimentacao: calculadoraRE.getAlimentacao(),
          cestaBeneficios: calculadoraRE.getBeneficios(),
          ajudaCusto: calculadoraRE.getAjudaCusto(),
          reembolsoDiverso: calculadoraRE.getReembolso(),
          valorAdicional: calculadoraRE.getValorAdicional(),
          premio: calculadoraRE.getPremio(),
          pida: calculadoraRE.getPida(),
          outrosDescontos: calculadoraRE.getOutrosDescontos(),
          dependentes: calculadoraRE.getDependentes(),
          inss: calculadoraRE.getInss(),
          irrf: calculadoraRE.getIrrf(),
          irrfComplementar: calculadoraRE.getIrrfComplementar(),
          liquidoSalario: calculadoraRE.getSalarioLiquido(),
          liquidoComplementar: calculadoraRE.getLiquidoComplementar(),
          pat: calculadoraRE.getPat(),
          totalLiquido: calculadoraRE.getTotalLiquido(),
        },
      },
    });
  return [enviarEmail, result];
};

export default useEnviarEmailSimulacao;
